import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function ValidationHero({ onGetStarted }) {
  return (
    <section className="pt-28 pb-16 bg-background border-b border-border">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-border bg-card text-xs font-medium text-muted-foreground mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-secondary animate-pulse" />
          Book a Free Compliance Review
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold text-foreground leading-tight tracking-tight mb-5">
          Free AI Validation Assessment for Small Regulated Labs
        </h1>
        <p className="text-base sm:text-lg text-muted-foreground leading-relaxed mb-6 max-w-2xl">
          Find out where AI can safely support your validation, QA, and documentation workflows — and where stronger controls, review steps, or audit evidence are still needed.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mb-5">
          <Button size="lg" className="w-full sm:w-auto gap-2" onClick={onGetStarted}>
            Book a Free Compliance Review
            <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
        <p className="text-sm text-muted-foreground">
          Built for small biotech, diagnostics, and pharma labs using AI in regulated quality work. No software replacement required. Start with one workflow and one clear answer.
        </p>
      </div>
    </section>
  );
}